import { EventLevelType, EventType, Notification } from 'entities/notification/model/types';
import { api } from 'shared/api';
import { ApiResponse } from 'shared/model/types';
import { setUserMeta } from 'shared/config/store/reducers/userSlice';

const notificationApi = api.injectEndpoints({
  endpoints: (build) => ({
    getNotifications: build.query<
      ApiResponse<{ count: number; unreaded: number; notifications: Notification[] }>,
      { eventType?: EventLevelType; limit?: number; offset?: number }
    >({
      query: ({ eventType, limit = 10, offset = 0 }) => ({
        url: `notification/get`,
        method: 'GET',
        params: {
          eventType:
            eventType === EventLevelType.Text
              ? EventType.TextNotification
              : eventType,
          limit,
          offset
        },
      }),
      keepUnusedDataFor: 10,
      providesTags: ['notifications']
    }),
    deleteNotification: build.mutation<ApiResponse<unknown>, { notificationId: number }>({
      query: ({ notificationId }) => ({
        url: `notification/${notificationId}/delete`,
        method: 'POST'
      }),
      invalidatesTags: ['notifications']
    }),
    setLevel: build.mutation<ApiResponse<{ success: boolean }>, EventLevelType>({
      query: (level) => {
        return {
          url: 'notification/setLevel',
          method: 'POST',
          params: {
            level,
          }
        }
      },
      onQueryStarted: async (level, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(setUserMeta({ notificationLevel: level }));
        } catch (error) {
          console.error('Failed to set notification level:', error);
        }
      },
    })
  })
});

export const { useGetNotificationsQuery, useSetLevelMutation, useDeleteNotificationMutation } = notificationApi;